// export { LgIconMenuComponent } from "./lg-icon-menu.component";

export * from "./lg-icon-menu.component";
